module.exports = __webpack_public_path__ + "img/wallet-one.d5c19f2b.svg";